import { Flex, Caption, Avatar, useStyles } from '@archipro-design/aria';
import React from 'react';
import { useDesignBoardCollaboratorsContext } from '@modules/design-board/component/manage/collaborator-overview/context/DesignBoardCollaboratorsContext';
import * as S from '@modules/design-board/component/manage-collaborators/MobileCollaboratorsModal.style';
import { CustomInvite } from '@archipro-design/icons';
import type { DesignBoardCollaborator } from '@modules/design-board/validation/types';
import { MobileCollaboratorListItem } from '@modules/design-board/component/manage-collaborators/MobileCollaboratorListItem';
import BottomDrawer from '~/modules/detail/components/bottom-drawer/BottomDrawer';

interface MobileCollaboratorsModalProps {
    title: string;
    collaborators: DesignBoardCollaborator[];
}

export const MobileCollaboratorsModal = ({
    title,
    collaborators,
}: MobileCollaboratorsModalProps) => {
    const { dispatch, state } = useDesignBoardCollaboratorsContext();
    const { css } = useStyles();
    const closeModal = () => {
        dispatch({
            type: 'modal-visibility',
            data: {
                visibility: 'hidden',
            },
        });
    };

    const collaboratorListItems = collaborators
        .filter(
            (c) =>
                c.membership === 'collaborators' &&
                !(
                    c.email === state.removingCollaborator?.email &&
                    state.removingCollaborator?.confirmed
                )
        )
        .map((c) => (
            <li key={`collaborator-${c.email}`}>
                <MobileCollaboratorListItem
                    name={c.name}
                    imageUrl={c.profileImageUrl}
                    membership={c.membership}
                    inviteStatus={c.inviteStatus}
                    email={c.email}
                    access={c.access}
                />
            </li>
        ));

    return (
        <BottomDrawer
            open={state.visibility === 'visible'}
            title={title}
            toggleModal={closeModal}
        >
            <div className={css(S.ModalContent)}>
                <div className={css(S.MainContent)}>
                    <ul className={css(S.CollaboratorsList)}>
                        <li key={`owner-${state.owner.name}`}>
                            <MobileCollaboratorListItem
                                name={state.owner.name}
                                imageUrl={state.owner.profileImageUrl}
                                membership={state.owner.membership}
                                inviteStatus={state.owner.inviteStatus}
                                email={state.owner.email}
                                access={state.owner.access}
                            />
                        </li>
                        {collaboratorListItems}
                    </ul>
                    <Flex
                        vAlign={'center'}
                        className={css(S.ExtraAction)}
                        onClick={closeModal}
                    >
                        <Avatar
                            icon={<CustomInvite />}
                            size={48}
                            variables={{
                                avatarBackgroundColor: '#EDEDED',
                            }}
                            className={css(S.Avatar)}
                        />
                        <Caption className={css(S.InviteCollaborator)}>
                            Invite collaborator
                        </Caption>
                    </Flex>
                </div>
            </div>
        </BottomDrawer>
    );
};
